var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-show',{attrs:{"fields":_vm.isProvider ? _vm.providerFields : _vm.makerFields,"resourceName":_vm.resourceName,"pk":_vm.pk,"breadcrumbs":_vm.breadcrumbs},on:{"check-maker":_vm.checkMaker}})}
var staticRenderFns = []

export { render, staticRenderFns }